module.exports = __webpack_public_path__ + "img/火箭.769c4e31.gif";